import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodeArticleTeaser from './Teaser';
import NodeArticlePage from './Page';
import type { NodeArticle } from '../../../types/uncinc_profile/nodes';

interface NodeArticleProps {
  entity: ImmutableEntity<NodeArticle>;
  viewMode: string;
  classes: string;
}

const NodeArticleWrapper: React.FC<NodeArticleProps> = ({ entity, viewMode, classes = '' }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeArticleTeaser entity={entity} classes={classes} />;
    default:
      return <NodeArticlePage entity={entity} />;
  }
};

export default NodeArticleWrapper;
